
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import ListBox from "@src/components/ListBox";
import GoogleMap from "@src/components/GoogleMap";
import InstaImage from "@src/components/InstaImage";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuGoldenBrownGoldenburgerTopImage } from "@src/constants/images";
export const meta = {
  path: "/media/harajuku/golden_brown",
  title: "【テイクアウトあり】表参道の人気ハンバーガー「ゴールデンブラウン」をご紹介！",
  description: "表参道の人気のハンバーガーショップ「ゴールデンブラウン」についてご紹介させていただきます。中目黒と表参道にお店を構え、人気は世界的にも取り上げられている名店。人気のメニューやテイクアウト情報など、ゴールデンブラウン に関するお役立ち情報をお届けします！",
  topImg: harajukuGoldenBrownGoldenburgerTopImage,
  author: murakamiMasanori,
  tags: ["原宿", "人気店", "お店の紹介", "ハンバーガー", "ガッツリ"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`表参道ヒルズにお店を構える人気のハンバーガーショップ「ゴールデンブラウン」についてご紹介させていただきます。`}</p>
    <p>{`中目黒と表参道にお店を構え、アメリカを思わせる外観や、その味は人気は世界的な雑誌にも取り上げられている名店。`}</p>
    <p>{`人気のメニューやテイクアウト情報など、ゴールデンブラウン に関するお役立ち情報をお届けします！`}</p>
    <h2>{`ゴールデンブラウン`}</h2>
    <InstaImage postId="B9zHrwrgqKU" mdxType="InstaImage" />
    <p>{`表参道ヒルズの 3 階に位置するゴールデンブラウンは、食べログのハンバーガー部門で 3 年連続百名店に選出されていて、毎年人気が向上しているお店です！
海外雑誌『monocle magazine』が選ぶ「世界の 100 アイテム」のベストバーガーに選出されたことがあるなど、ハンバーガー業界では知らない人はいない名店。
そんなゴールデンブラウン についてご紹介させていただきます！`}</p>
    <h3>{`都内に２店舗`}</h3>
    <InstaImage postId="B-EE03xp22A" mdxType="InstaImage" />
    <InstaImage postId="B-9dkJrDYJ1" mdxType="InstaImage" />
    <p>{`表参道と中目黒に店舗を構えています。ハンバーガーの中でも、ちょっと大人な客層をターゲットとしたハンバーガーショップになっています。
普段とは違った落ち着いた空間が好きな方には、オススメなエリアになっています。`}</p>
    <h3>{`昔のアメリカを思わせる店内`}</h3>
    <InstaImage postId="B3ZGcs3F9yK" mdxType="InstaImage" />
    <p>{`ゴールデンブラウンの店内は、昔のアメリカを思わせるようなクラシックな雰囲気の店内になっています。
店内のメニュー一覧が、英語で黒板に書かれているのを見ると、田舎町の一角のハンバーガショップを思い出させてくれる、そんな雰囲気はまさに非日常な空間があります。
これが表参道で味わえるなんて良いですよね。`}</p>
    <hr></hr>
    <h2>{`ゴールデンブラウンの人気のメニュー３選`}</h2>
    <p>{`ゴールデンブラウンには一生多くのハンバーガーメニューがありますが、その中でも今回は特に人気のメニュー３つに絞ってご紹介させていただきたいと思います！
表参道エリアも中目黒のエリアもメニューは基本的には同じなので、ご安心ください。`}</p>
    <h3>{`ゴールデンブラウンハンバーガー(871 円)`}</h3>
    <InstaImage postId="Bv3Q7JNHbj0" mdxType="InstaImage" />
    <p>{`ゴールデンブラウン の王道のメニューが、こちらのゴールデンブラウン ハンバーガー！
焼き加減バッチリな香ばしいバンズとピリッと塩気のあるパテの相性が抜群のメニューになっています！`}</p>
    <h3>{`アボカドチーズハンバーガー(1,306 円)`}</h3>
    <InstaImage postId="B94I9y4H8je" mdxType="InstaImage" />
    <p>{`アボカドの鮮度とハンバーガーのパテの相性を合わせるのがハンバーガー業界では難しいと言われていますが、ゴールデンブラウンではアボカドが程よくクリーミーな味わいでピリッとしたパテとの相性が抜群のハンバーガーになっています！`}</p>
    <h3>{`ベーコンチーズバーガー(1,167 円)`}</h3>
    <InstaImage postId="B91DmjnABaq" mdxType="InstaImage" />
    <p>{`香ばしく香り豊かなベーコンと、トロトロのチーズにピリッと効いたバンズが楽しめる人気メニューになっています。
値段はアボカドチーズバーガーと比べるとリーズナブルなのに、ボリューム感がたっぷりあるハンバーガーになっています！`}</p>
    <hr></hr>
    <h2>{`テイクアウト`}</h2>
    <p>{`ゴールデンブラウンではテイクアウトができます！
コロナによる影響で、人混みを避けてハンバーガーを食べたい方、自宅でゆっくり食事がしたい方には、テイクアウトがおすすめです！
表参道付近で働いている会社員の方も、平日にはテイクアウト で訪れる方が多いそうですよ！`}</p>
    <h3>{`デリバリーもある！？`}</h3>
    <p>{`Uber Ents がスタートしたので、ハンバーガーをご自宅で楽しむことができます！
テイクアウトも面倒くさいけど、美味しいハンバーガーが食べたい方にはデリバリーがおすすめです！`}</p>
    <hr></hr>
    <h2>{`支払い方法`}</h2>
    <ListBox list={["クレカ：○", "電子マネー：○", "現金：○"]} mdxType="ListBox" />
    <p>{`ゴールデンブラウンの表参道店では、電子マネーまで使えるようになっており、誰もが行きやすいお店になっています！
現金を普段持ち歩かない方には必見のお店になっています！`}</p>
    <hr></hr>
    <h2>{`アクセス`}</h2>
    <p>{`表参道ヒルズの３階に店舗を構えており、黒い外観のアメリカンスタイルのお店になので、すぐに場所がわかると思います。
表参道付近にお越しの方、表参道ヒルズに用事やデートでお越しの際には、ゴールデンブラウンで素敵な食事をお過ごしください！`}</p>
    <GoogleMap lat={35.6582645} lng={139.6913639} mdxType="GoogleMap" />
    <hr></hr>
    <h3>{`おわりに　`}</h3>
    <p>{`表参道の人気ハンバーガーショップ「ゴールデンブラウン」についてご紹介させていただきました！
普段食べているハンバーガーとは違うハンバーガーを食べたい、ガッツリハンバーガーを食べたい時には、3 年連続百名店に選ばれている「ゴールデンブラウン 」でお楽しみください！`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;